<template>
  <div class="complete-item" @click="clickEvent(item)">
    <div class="complete-item__img" :style="[stateWindowWidth >= 768 ? {height: imgHeight[index] + 'px'} : '']">
      <div
        class="item__enlarge-button"
        @click.stop="imgOpen(item.thumbnail)">
        <div class="item__enlarge-icon"></div>
      </div>
      <div class="item__img-overlay" @click.stop="imgOpen(item.thumbnail)"></div>
      <v-item-img class="complete-item__item-img" :src="item.thumbnail" :alt="item.name" @height="$emit('height', $event)"/>
    </div>

    <div class="complete-item__body">
      <div class="complete-item__name">{{ item.name }}<span v-if="item.soldout" class="complete-item__soldout">売り切れ</span></div>
      <div class="complete-item__description" v-if="item.description">{{ item.description }}</div>
      <div class="complete-item__size" v-if="item.size">{{ item.size }}</div>
      <div class="complete-item__price" v-if="item.priceIncTax">
        <span class="complete-item__price__title">金額</span>
        <span class="complete-item__price__num">{{ item.priceIncTax | money }}</span>
        <span class="complete-item__price__jpy">円</span>
      </div>
      <div class="complete-item__submit">
        <button
          class="complete-item__button"
          :class="{
            'is-loading': pageLoading,
            'is-soldout': item.soldout
          }"
          @click="clickEvent(item)"
          :disabled="pageLoading">
          <span v-if="item.soldout" class="position-r">売り切れ商品を変更する</span>
          <span v-else class="position-r">変更する</span>
        </button>
      </div>
    </div>

    <v-prev-dialog v-model="prevDialog.state" message="サイズ、人数へ戻ると今まで選択した商品がリセットされます。"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-item-img': require('@/components/item-img.vue').default,
    'v-prev-dialog': require('@/components/prev-dialog.vue').default,
  },
  props: {
    index: Number,
    item: Object,
    filter: Array,
    imgHeight: Object,
  },
  computed: {
    ...mapState({
      stateWindowWidth: state => state.window.width,
      pageLoading: state => state.page.loading,
    }),
  },
  watch: {
    windowWidth: {
      handler(val) {
        this.windowWidth = this.stateWindowWidth
      },
      deep: true
    },
  },
  data() {
    return {
      itemShow: true,
      active: false,
      windowWidth: false,
      dialogReset: {
        state: false
      },
      dialogChild: {
        state: false,
        message: '',
        src: '',
      },
      prevDialog: {
        state: false,
      }
    }
  },
  methods: {
    queryGet() {
      let query = Object.assign({}, this.$route.query)
      let query_item = Number(query['order_' + this.$route.params.order])

      if (query_item === this.item.id) {
        this.$store.commit('step/selectItemSet', this.item)
        this.active = true
      }
    },
    refine() {
      for (let i=0; i<this.stateLists.length; i++) {
        if (this.stateSelectItem && this.stateSelectItem.id === this.item.id) {
          this.itemShow = true
        } else if (this.stateLists[i].id === this.item.list.id && this.stateLists[i].refine) {
          this.itemShow = true
        } else if (this.stateLists[i].id === this.item.list.id && !this.stateLists[i].refine) {
          this.itemShow = false
        }
      }
    },
    itemClickEvent() {
    },
    clickEvent(item) {
      if (String(item.page.order) === '1' || String(item.page.order) === '2') {
        this.$set(this.prevDialog, 'state', true)
      } else {
        let root = this.$route.path.match(/gogatsu/) ?  this.config.path.root_gogatsu : this.config.path.root;
        this.$router.push({
          path: root + '/step/' + item.page.slug + '/' + item.page.order,
          query: this.$route.query
        })
      }
    },
    itemSelect() {
      let query = Object.assign({}, this.$route.query)

      if (!this.stateSelectItem || this.stateSelectItem.id !== this.item.id) {
        this.$store.commit('step/selectItemSet', this.item)
        console.log('select item')
        console.log(this.item)
        query['order_' + this.$route.params.order] = this.item.id
        this.$router.replace({ query: query })
      } else if (!this.stateCurrent.required) {
        this.$store.commit('step/selectItemSet', null)
        query['order_' + this.$route.params.order] = 'null'
        this.$router.replace({ query: query })
      } else {
        delete query['order_' + this.$route.params.order]
        this.$router.replace({ query: query })
        this.$store.commit('step/selectItemSet', null)
      }

      let order = this.$route.params.order
      this.$store.commit('cart/itemsSet', {
        order: order,
        orderName: 'order_' + order,
        item: this.item,
        state: !this.active,
      })
      if (this.item.position) {
        this.$store.commit('canvas/itemsSet', {
          index: order,
          item: this.item,
          state: !this.active,
        })
      }
    },
    activeWatch() {
      if (!this.stateSelectItem) {
        this.active = false
      } else if (this.stateSelectItem.id === this.item.id) {
        this.active = true
      } else {
        this.active = false
      }
    },
    imgOpen(img) {
      this.$confirm('<img class="el-message-box__img" src="' + img + '" alt="">', {
        showConfirmButton: false,
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        customClass: 'item-modal',
        callback: (action) => {}
      })
    },
    dialogChildHandler() {
      for (let key in this.cart) {
        if (key === 'order_' + this.$route.params.order + '-1') {
          this.$set(this.dialogChild, 'message', this.cart[key].name)
          this.$set(this.dialogChild, 'src', this.cart[key].thumbnail)
        }
      }

      this.$set(this.dialogChild, 'state', true)
    },
  }
}
</script>



<style lang="scss">
.complete-item {
  $e: &;
  display: flex;
  transition: $transition;
  position: relative;
  z-index: 1;
  border-top: 1px solid $oc-gray-2;
  background-color: #fff;
  width: 100%;
  &:last-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  @include active() {
    z-index: 2;
    box-shadow: 0 8px 17px 2px rgba(#000, 0.07), 0 3px 14px 2px rgba(#000, 0.06), 0 0 5px -3px rgba(#000, 0.1);
    border-top-color: transparent;
    & + #{$e} {
      border-top-color: transparent;
    }
  }
  @include breakpoints-min(md) {
    display: block;
    border-top: none;
    width: 240px;
    margin: 32px;
    padding-bottom: 50px;
    &:last-child {
      border-bottom: none;
    }
    @include active() {
      box-shadow: none;
    }
  }
  &.is-active {
    box-shadow: none;
    background-color: #fff2f4;
    #{$e}__button {
      border-color: $accent-color;
      background-color: $accent-color;
      color: #fff;
      @include hover() {
        border-color: $accent-color;
        background-color: $accent-color;
        color: #fff;
      }
      @include active() {
        border-color: #826c63;
        background-color: #826c63;
        color: #fff;
      }
      @include breakpoints-min(lg) {
        border-color: #947c72;
        background-color: #947c72;
        @include hover() {
          border-color: #947c72;
          background-color: #947c72;
          color: #fff;
        }
        @include active() {
          border-color: #826c63;
          background-color: #826c63;
          color: #fff;
        }
      }
    }
    #{$e}__enlarge-button {
      &::after {
        background-color: #f1aab7;
      }
      @include breakpoints-min(md) {
        &::after {
          background-color: #d4d2d2;
        }
      }
    }
    .item-img {
      &::after {
        border: 1px solid rgba($accent-color, 0.5);
      }
    }
    @include breakpoints-min(md) {
      background-color: transparent;
    }
  }
  &__body {
    display: block;
    width: calc(100% - 136px);
    padding: 12px 12px 12px 0;
    @include breakpoints-min(md) {
      width: auto;
      padding: 0;
    }
  }
  &__name {
    font-family: $serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 0.05em;
    color: #000;
    margin: 0 2px 4px;
    @include breakpoints-min(md) {
      font-size: 15px;
      text-align: center;
      letter-spacing: 0.08em;
      color: #212529;
      margin: 12px 0 12px;
    }
  }
  &__soldout {
    display: inline-block;
    background-color: $accent-color;
    font-family: $sans-serif;
    font-size: 13px;
    color: #fff;
    margin-left: 8px;
    padding: 2px 6px;
    @include breakpoints-min(md) {
      display: none;
    }
  }
  &__description {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: 0.1em;
    margin: 4px 2px 2px;
    @include breakpoints-min(md) {
      font-size: 11px;
      text-align: justify;
      color: #757473;
      margin: 0 0 8px;
    }
  }
  &__size {
    font-size: 10px;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: 0.02em;
    margin: 4px 2px 4px;
    @include breakpoints-min(md) {
      line-height: 1.4;
      letter-spacing: 0.14em;
      text-align: center;
      color: #757473;
      margin: 0 0 6px;
    }
  }
  &__price {
    font-weight: 400;
    line-height: 1;
    margin: 8px 2px 4px;
    @include breakpoints-min(md) {
      text-align: center;
      margin: 0;
    }
    &__title {
      display: inline-block;
      font-size: 10px;
      letter-spacing: 0.08em;
      margin-right: 8px;
      @include breakpoints-min(md) {
        font-size: 10px;
        color: #757473;
        margin-right: 12px;
      }
    }
    &__num {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      @include breakpoints-min(md) {
        font-family: $serif;
        font-size: 15px;
      }
    }
    &__jpy {
      display: inline-block;
      font-size: 10px;
      font-weight: 500;
      margin-left: 2px;
      @include breakpoints-min(md) {
        font-family: $serif;
        font-size: 10px;
        font-weight: 500;
        color: #423f3d;
        margin-left: 4px;
      }
    }
  }
  &__enlarge-button {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 5px;
    right: 13px;
    z-index: 3;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
    }
    &::before {
      z-index: 2;
      background-color: #fff;
      width: 20px;
      height: 20px;
    }
    &::after {
      transition: 0.25s linear;
      z-index: 1;
      background-color: #d4d2d2;
      width: 22px;
      height: 22px;
    }
    @include breakpoints-min(md) {
      top: -20px;
      right: 0;
      width: 42px;
      height: 42px;
      &::before {
        width: 40px;
        height: 40px;
      }
      &::after {
        width: 44px;
        height: 44px;
      }
      @include hover() {
        &::after {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
  &__enlarge-icon {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
      border: 1px solid $oc-gray-9;
      width: 8px;
      height: 8px;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 8px;
      left: 6px;
      transform: rotate(45deg);
      background-color: $oc-gray-9;
      width: 3px;
      height: 1px;
    }
    @include breakpoints-min(md) {
      width: 16px;
      height: 16px;
      &::before {
        width: 14px;
        height: 14px;
      }
      &::after {
        top: 13px;
        left: 11px;
        width: 5px;
      }
    }
  }
  &__img-overlay {
    cursor: pointer;
    position: absolute;
    top: 8px;
    left: 16px;
    z-index: 3;
    width: calc(100% - 32px);
    height: calc(100% - 16px);
    @include breakpoints-min(md) {
      display: none;
    }
  }
  &__submit {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  &__button {
    display: none;
    cursor: pointer;
    appearance: none;
    transition: $transition;
    outline: none;
    border-radius: 4px;
    border: 1px solid #ccc9c8;
    background-color: transparent;
    font-family: inherit;
    font-weight: 500;
    font-size: 11px;
    text-align: center;
    line-height: 36px;
    color: #67615f;
    width: 100%;
    height: 36px;
    padding: 0;
    &:disabled {
      cursor: no-drop;
      border-color: $oc-gray-3;
      background-color: $oc-gray-3;
      color: $oc-gray-6;
      @include hover() {
        border-color: $oc-gray-3;
        background-color: $oc-gray-3;
        color: $oc-gray-6;
      }
      @include active() {
        border-color: $oc-gray-3;
        background-color: $oc-gray-3;
        color: $oc-gray-6;
      }
    }
    &.is-loading {
      cursor: no-drop;
      border-color: $oc-gray-3;
      background-color: transparent;
      color: $oc-gray-6;
      @include hover() {
        border-color: $oc-gray-3;
        background-color: transparent;
        color: $oc-gray-6;
      }
      @include active() {
        border-color: $oc-gray-3;
        background-color: transparent;
        color: $oc-gray-6;
      }
    }
    &.is-soldout {
      border-color: $accent-color;
      background-color: $accent-color;
      color: #fff !important;
      @include hover() {
        border-color: $accent-color-hover;
        background-color: $accent-color-hover;
        color: #fff;
      }
      @include active() {
        border: 1px solid $accent-color-active;
        background-color: $accent-color-active;
        color: #fff;
      }
    }
    @include breakpoints-min(md) {
      display: block;
      @include hover() {
        border-color: $accent-color;
        color: $accent-color;
      }
      @include active() {
        border: 1px solid $accent-color;
        background-color: $accent-color-bg;
        color: $accent-color;
      }
    }
    @include breakpoints-min(lg) {
      @include hover() {
        border-color: #9e8a82;
        color: #75645b;
      }
      @include active() {
        border: 1px solid #9e8a82;
        background-color: #f5f1f0;
        color: #75645b;
      }
    }
  }

  &__img {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: $transition;
    position: relative;
    line-height: 1;
    width: 136px;
    padding: 8px;
    @include active() {
      transform: scale(1.1);
    }
    @include breakpoints-min(md) {
      width: auto;
      padding: 0 12px;
      @include active() {
        transform: scale(1);
      }
    }
  }
  .item-img {
    display: block;
    position: relative;
    z-index: 1;
    background-color: #fff;
    font-size: 0;
    width: calc(100% - 16px);
    padding: 8px;
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      border: 1px solid rgba($oc-gray-8, 0.1);
      width: 100%;
      height: 100%;
    }
    @include breakpoints-min(md) {
      top: auto;
      left: auto;
      transform: none;
      width: auto;
      &::after {
        display: none;
      }
    }
  }
}

.app-gogatsu {
    .complete-item{
        &.is-active {
            box-shadow: none;
            background-color: #fff2f4;
            .complete-item__button {
                border-color: $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                color: #fff;
                @include hover() {
                    border-color: $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color;
                    color: #fff;
                }
            }
            .complete-item__enlarge-button {
                &::after {
                    background-color: $gogatsu-accent-color-disabled;
                }
                @include breakpoints-min(md) {
                    &::after {
                        background-color: #d4d2d2;
                    }
                }
            }
            .item-img {
                &::after {
                    border: 1px solid rgba($gogatsu-accent-color, 0.5);
                }
            }
            @include breakpoints-min(md) {
                background-color: transparent;
            }
        }
        &__soldout {
            background-color: $gogatsu-accent-color;
            color: #fff;
        }
        &__button {
            &.is-soldout {
                border-color: $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                color: #fff !important;
                @include hover() {
                    border-color: $gogatsu-accent-color-hover;
                    background-color: $gogatsu-accent-color-hover;
                    color: #fff;
                }
                @include active() {
                    border: 1px solid $gogatsu-accent-color-active;
                    background-color: $gogatsu-accent-color-active;
                    color: #fff;
                }
            }
            @include breakpoints-min(md) {
                display: block;
                @include hover() {
                    border-color: $gogatsu-accent-color;
                    color: $gogatsu-accent-color;
                }
                @include active() {
                    border: 1px solid $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color-bg;
                    color: $gogatsu-accent-color;
                }
            }
        }
        
    }

}
</style>
